<template>

	<!-- Contents-->
	<div class="content">
		<h2 class="tit_page">{{ courseVO.title }}</h2>
<!--			<div class="board_category swiper-container">
			<ul class="swiper-wrapper">
				<li class="swiper-slide active"><button type="button">교육과정</button></li>
				<li class="swiper-slide"><button type="button">교육과목</button></li>
			</ul>
		</div>-->
		<div class="curriculum_head">
			<figure class="learning_thumb">
				<img v-if="courseVO.thumbnail != null && courseVO.thumbnail !== ''" :src="courseVO.thumbnail" alt="" style="object-fit: cover; aspect-ratio: 1 / 1;">
				<img v-else src="/ssflex/assets/img/common/img_thumb.svg">
			</figure>
			<div class="learning_text">
				<em class="cate">
					<span class="notice_cate">{{ courseVO.shortTitle }}</span>
					<span v-if="courseVO.cateCodeVO != null">{{ courseVO.cateCodeVO.codeName }}</span>
					<!--<span>기타</span>-->
				</em>
				<h2 class="tit">{{ courseVO.title }}</h2>
				<div class="info">
					<dl>
						<dt>일정</dt>
						<dd>
							<template v-if="!$options.filters.isEmpty(courseVO.startDate)">
								{{ courseVO.startDate | scheduleFilter( courseVO.scheduleMode ) }}
							</template>
							-
							<template v-if="!$options.filters.isEmpty(courseVO.endDate)">
								{{ courseVO.endDate | scheduleFilter( courseVO.scheduleMode ) }}
							</template>
						</dd>
					</dl>
					<dl v-if="!$options.filters.isEmpty(courseVO.teacherName)">
						<dt>강사</dt>
						<dd>{{ courseVO.teacherName }}</dd>
					</dl>
				</div>
			</div>
		</div>

		<!-- 교과정 내 교육목록 -->
		<template v-if="courseVO.eduMainList != null && courseVO.eduMainList.length > 0">
			<div class="board_sort" >
				<div class="total_box">총 <b>{{ courseVO.eduMainList.length }}</b>건</div>
				<!--				<ul class="sort_box">
								<li class="active"><button type="button">최신순</button></li>
								<li><button type="button">강좌순</button></li>
								<li><button type="button">조회순</button></li>
							</ul>-->
			</div>
			<div class="board_list">
				<ul class="webzine_list">
					<!-- 웹진(교육과정) 게시판은 게시글 4개 -->
					<li v-for="(item, index) in courseVO.eduMainList">
						<a href="javascript:;" @click="goEduMain(item);">
							<figure class="list_thumb">
								<img v-if="item.thumbnail != null && item.thumbnail !== ''" :src="item.thumbnail" alt="" style="object-fit: cover; aspect-ratio: 1 / 1;">
								<img v-else src="/ssflex/assets/img/common/img_thumb.svg">
							</figure>
							<div class="list_text">
								<em class="cate">
									<span class="notice_cate" v-if="item.cateCode != null">{{ item.cateCodeVO.codeName }}</span>
									<span v-if="item.isMajor">주요교육</span>
								</em>
								<strong class="tit">
									{{ item.shortTitle }} {{ item.eduTitle }}
								</strong>
								<div class="desc">{{ item.introduce }}</div>
							</div>
						</a>
					</li>
				</ul>
			</div>
		</template>

		<div class="btn_wrap" style="text-align: center; margin-top: 30px;">
			<button type="button" class="btn btn-lg btn-dark btn_learn" @click="goBackList">목록으로</button>
		</div>
	</div>


</template>

<script>
import Qs from "qs";

export default {
	name: "courseDetail",
	prop: {
		cidx: Number,
		eduCourse: Object,
	},
	data() {

		const userId = this.getLoginId()

		return {

			userId,

			cidx: this.$route.query.cidx,
			courseVO: new this.EduCourseVO(),
		}
	},
	created() {

		this.getCourseDetail( this.cidx, this.userId );

	},
	mounted() {

		//this.getWishLike( this.emIdx, this.userId );

	},
	updated() {

	},
	methods: {



		getCourseDetail: function (_cidx, _userId) {

			var self = this

			self.$eventBus.$emit("startProgress")
			this.axiosCaller.get(this, this.APIs.EDU_COURSE + "/", {
				cidx : _cidx,
				userId : _userId,
			}, function (res) {
				self.$eventBus.$emit("doneProgress")

				const result = res.data
				console.log(result)
				if ( result.status === "ok" && result.list.length > 0 ) {
					self.courseVO = result.list[0];
				}
				//console.log("allContentCnt ::::: " + self.allContentCnt)
			})

		},


		goEduMain ( _item ) {

			this.$router.push({
				path: '/app/education/main/',
				query: {
					mode: "learn",
					emIdx: _item.emIdx,
					cateCode: _item.cateCode,
				},
			},).catch((e) => {
				console.log(e)
			})
			this.webUtils.scrollTo("#app")

		},


		goBackList(e) {
			history.back();
		},



	}
}
</script>

<style scoped>

</style>
